import {
	reAdministrativeTerritoryConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : null,
	pagedAudit : {},
	list       : null,
	changed    : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reAdministrativeTerritoryConstants.GetPaged.REQUEST:
		case reAdministrativeTerritoryConstants.GetPagedAll.REQUEST:
		case reAdministrativeTerritoryConstants.GetPagedAudit.REQUEST:
		case reAdministrativeTerritoryConstants.GetList.REQUEST:
		case reAdministrativeTerritoryConstants.Create.REQUEST:
		case reAdministrativeTerritoryConstants.Delete.REQUEST:
		case reAdministrativeTerritoryConstants.Restore.REQUEST:
		case reAdministrativeTerritoryConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reAdministrativeTerritoryConstants.GetPaged.FAILURE:
		case reAdministrativeTerritoryConstants.GetPagedAll.FAILURE:
		case reAdministrativeTerritoryConstants.GetPagedAudit.FAILURE:
		case reAdministrativeTerritoryConstants.GetList.FAILURE:
		case reAdministrativeTerritoryConstants.Create.FAILURE:
		case reAdministrativeTerritoryConstants.Delete.FAILURE:
		case reAdministrativeTerritoryConstants.Restore.FAILURE:
		case reAdministrativeTerritoryConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reAdministrativeTerritoryConstants.GetPaged.SUCCESS:
		case reAdministrativeTerritoryConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reAdministrativeTerritoryConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result
			}
		case reAdministrativeTerritoryConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reAdministrativeTerritoryConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reAdministrativeTerritoryConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reAdministrativeTerritoryConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reAdministrativeTerritoryConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reAdministrativeTerritoryConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : null,
				pagedAudit : {},
				list       : null
			}
		default:
			return state
	}
}